<template>
  <LoginLayout
    type="login"
    title="Sign in"
    button-title="Login"
    :submitting="submitting"
    @on-submit="login"
  >
    <LmInput ref="email" type="email" label="Email" :maxlength="0" focus />
    <LmInput
      ref="pass"
      type="password"
      label="Password"
      :maxlength="0"
      custom-rule="loginPassword"
    />
  </LoginLayout>
</template>

<script>
import auth from '@/lib/auth'
import LoginLayout from './LoginLayout.vue'
import LmInput from '@/components/form/LmInput.vue'
import {newAlert} from '@/lib/eventHub'
import {Alert, AlertMessages} from '@/lib/definitions'

export default {
  name: 'LoginView',
  components: {
    LoginLayout,
    LmInput
  },
  data() {
    return {
      submitting: false
    }
  },
  methods: {
    login() {
      let valid = true
      for (let ref in this.$refs) {
        if (!this.$refs[ref].validateData()) {
          valid = false
        }
      }
      if (valid) {
        this.submitting = true
        auth.auth0.redirect.loginWithCredentials(
          {
            connection: 'Username-Password-Authentication',
            username: this.$refs.email.data,
            password: this.$refs.pass.data,
            state: this.$route.query.returnURL,
            scope: 'openid state'
          },
          error => {
            console.log('LoginView => ', error)
            let msg = AlertMessages.LOGIN_ERROR + ' ' + error.description
            newAlert(msg, Alert.ERROR, false)
            this.submitting = false
          }
        )
      }
    }
  }
}
</script>
